import React from 'react';
import moment from 'moment';
import { Card, Button, Icon } from 'antd';
import { IProps, INotifyInfo } from '../../../domain/model';
import { isContractRenewGuideTarget } from '../../../domain/common';
import './contractRenewGuide.css';

/* eslint-disable react/no-unescaped-entities */
export default function ContractRenewGuide({ state }: IProps): JSX.Element {
  /**
   * 次年度更新ガイドの表示要否を判定する。
   * @returns true: 対象サービスが未更新（isRenewedがfalse）、かつ次年度更新申込期間内または契約期間外
   * （isNotifyまたはisOutOfRangeがtrue）、かつ約款改定日以降（isNewPriceRequiredがtrue）の場合
   * false: 次年度更新済みの場合や、約款改定日より前の場合
   */
  const isVisible = state.notifyInfo.some((notification: INotifyInfo) => isContractRenewGuideTarget(notification));

  // 次年度更新 専用申込フォームのURL。
  // state.subscriptionInfoの1件目（当月時点の契約）のsubscriptionEndDateは、バックエンドでZuora上の
  // 契約終了日（次サイクル開始日扱い）から1日引いた値になっている（dbp_invoice_backend bffUtil.ts
  // createContractInfoのgetYesterday）。設計上の判定基準はZuora上の生値とREACT_APP_CONTRACT_RENEW_FORM_SWITCH_DATE
  // の比較のため、switchDate側も1日引いて相殺し、Zuora生値どうしの比較と同じ結果にする。
  const switchDate = process.env.REACT_APP_CONTRACT_RENEW_FORM_SWITCH_DATE;
  const adjustedSwitchDate = switchDate
    ? moment(switchDate)
        .subtract(1, 'day')
        .format('YYYY-MM-DD')
    : undefined;
  const currentSubscriptionEndDate = state.subscriptionInfo[0]?.subscriptionEndDate;
  const renewFormUrl =
    adjustedSwitchDate && currentSubscriptionEndDate && currentSubscriptionEndDate >= adjustedSwitchDate
      ? process.env.REACT_APP_CONTRACT_RENEW_FORM_URL_AFTER
      : process.env.REACT_APP_CONTRACT_RENEW_FORM_URL_BEFORE;

  // 次年度更新 専用申込フォームのお申込み方法マニュアルのURL
  const renewFormManualUrl = process.env.REACT_APP_CONTRACT_RENEW_FORM_MANUAL_URL;

  return (
    <div className="priceRevisionGuide contractRenewGuide" hidden={!isVisible}>
      <Card bordered={false}>
        <p className="guideTitle">【重要】次年度更新のお申込み方法について</p>
        <p>
          2027年4月1日より、料金を改定いたします。
          <br />
          料金改定に伴うシステム対応のため、現在、本画面からの「次年度更新申込」を停止しております。
          <br />
          お手数をおかけいたしますが、以下の専用申込フォームよりお手続きくださいますようお願いいたします。
        </p>
        <Button type="primary" className="guideFormBtn" href={renewFormUrl} target="_blank" rel="noopener noreferrer">
          次年度更新 専用申込フォームはこちら
          <Icon style={{ fontSize: '18px' }} type="play-circle" />
        </Button>
        <p className="guideSubTitle">お手続きの流れ</p>
        <ol>
          <li>上記ボタンをクリック後、「メールアドレスでログイン」をクリックしてください。</li>
          <li>入力欄が表示されますので、企業担当者様のメールアドレスを入力し、「送信する」ボタンをクリックしてください。</li>
          <li>ご入力のアドレス宛に、件名『【トヨクモ kintone 連携サービス】ログイン用メール』が届きます。</li>
          <li>
            メール内のリンクから申込フォームを開き、必要事項を入力のうえ送信してください。
            <br />
            （⚠ メールが届かない場合は、送信元アドレス「noreply@kintoneapp.com」からのメールが受信可能な設定になっているか、ご確認ください）
          </li>
          <li>弊社にてお申込み内容を確認いたします。</li>
          <li>ご請求書およびお見積書の作成完了後、企業担当者様のメールアドレス宛に完了のご案内をお送りします。</li>
          <li>ご請求書およびお見積書は、これまでどおり本画面よりダウンロードしてください。</li>
        </ol>
        <p className="noticeManual">
          お申込み方法については以下マニュアルをご参照ください。
          <br />
          <a className="noticeManualLink" href={renewFormManualUrl} target="_blank" rel="noopener noreferrer">
            申込マニュアルはこちら
            <Icon className="noticeManualIcon" type="select" />
          </a>
        </p>
        <p className="guideNote">
          ※ご請求書の作成には、通常3営業日程度かかります。
          <br />
          ※お申込み内容や受付状況により、作成までの日数が前後する場合がございます。あらかじめご了承ください。
          <br />
          <span className="guideNoteWarning">※メールに記載されたURLは誤って他社に転送しないようご注意ください。</span>
        </p>
      </Card>
    </div>
  );
}
